import type {
	AutocompleteReshapeSource,
	AutocompleteReshapeSourcesBySourceId,
} from '@algolia/autocomplete-core'

import {
	shouldFetchAutocompleteForQuery,
	shouldShowCuratedAutocompleteSections,
} from '@/utils/algolia/autocomplete/utils'

import type { PluginHit } from '../plugins'

type PrefetchedSearchByAudio = {
	title?: string
	url?: string
} | null

export const getReshapedAutocompleteSources = ({
	query,
	prefetchedSearchByAudio,
	sourcesBySourceId,
	isStreamingServiceLink,
	keywordSearchMode = true,
}: {
	query: string | undefined
	prefetchedSearchByAudio: PrefetchedSearchByAudio | undefined
	sourcesBySourceId: AutocompleteReshapeSourcesBySourceId<PluginHit>
	isStreamingServiceLink: (link: string) => boolean
	keywordSearchMode?: boolean
}): Array<AutocompleteReshapeSource<PluginHit>> => {
	const {
		suggestionsAndPromptSource: suggestionsAndPrompt,
		facetsSource: facets,
		playlistsSource: playlists,
		collectionsSource: collections,
	} = sourcesBySourceId

	if (!keywordSearchMode) {
		return []
	}

	// Prefetched title: hide panel without running `isStreamingServiceLink`
	if (prefetchedSearchByAudio?.title) {
		return []
	}

	const isAudioUrl = Boolean(query && isStreamingServiceLink(query))
	if (isAudioUrl) {
		return []
	}

	if (!query || query.length === 0) {
		return []
	}

	if (!shouldFetchAutocompleteForQuery(query)) {
		return []
	}

	if (!shouldShowCuratedAutocompleteSections(query)) {
		return [suggestionsAndPrompt].filter(Boolean) as Array<
			AutocompleteReshapeSource<PluginHit>
		>
	}

	return [suggestionsAndPrompt, facets, playlists, collections].filter(
		Boolean
	) as Array<AutocompleteReshapeSource<PluginHit>>
}
